// ----------------------------------------------------------------------

export default function Container(theme) {
    return {
        MuiContainer: {
            defaultProps: {
                maxWidth: 'xl',
            },
        },
    };
}
